import React, {useContext, useEffect, useState} from "react";
import './MapPage.scss';
import { GlobalApiFactory, HomePlant } from '../../Services/typescript-fetch-client/api';
import { Button } from 'primereact/button';
import {InteractionRequiredAuthError} from '@azure/msal-browser';
import decimalRound from "../../Utils/decimalRound";
import ProfiliCaricoContext, {MainContext} from "../../Context/ProfiliCaricoContext";
import CustomSidebar from "../../Components/CustomSidebar/CustomSidebar";
import MapComponent from "../../Components/MapComponent/MapComponent";
import formatNumber from "../../Utils/formatNumber";
import HomeAccordionTableComponent from "../../Components/HomeAccordionTableComponent/HomeAccordionTableComponent";
import isMobile from "is-mobile";
import MiniAccordionTable from "../../Components/MiniAccordionTable/MiniAccordionTable";
import useWindowDimensions from "../../Components/ui-components/useWindowDimensions";

const MapPage = () => {
    const [homePlants, setHomePlants] = useState<HomePlant[]>([]);
    const [bodyRealHeightMobile, setBodyRealHeightMobile] = useState<number | null>(null);
    const context = useContext(ProfiliCaricoContext);
    const { height, width } = useWindowDimensions();
    
    useEffect(() => {
        if (context.accessToken) {
            refreshData(context, setHomePlants);
            
            let timeout = setInterval(() => refreshData(context, setHomePlants), 300000);
            return () => {
                clearTimeout(timeout);
            };
        }
    }, [context.accessToken]);

    useEffect(() => {
        if(isMobile({featureDetect: true, tablet: true})) {
            const lEv = function () {
                let actualVisibleHeight = document.documentElement.clientHeight;
                let totalViewportHeight = window.innerHeight;
                let headerHeight = getComputedStyle(document.querySelector("#app-header")!)["height"];
                let actualHeaderH = Number(headerHeight.replace("px", ""));
                //console.log("Computing heights. actualVisible=" + actualVisibleHeight + " | totalViewport=" +totalViewportHeight 
                //    + " | headerHStr=" + headerHeight + " | actualHeader=" + actualHeaderH + " | actualBody=" + (actualVisibleHeight - actualHeaderH));
               /*  console.log("MOBILE: ", actualVisibleHeight);
                if (actualVisibleHeight < 740) {
                    console.log("CIOAOOSDOW");
                    
                    setBodyRealHeightMobile(actualVisibleHeight - actualHeaderH);
                } else if (actualVisibleHeight > 1800) {
                    setBodyRealHeightMobile(actualVisibleHeight - actualHeaderH);
                } else {
                    setBodyRealHeightMobile(actualVisibleHeight - actualHeaderH);
                } */

                setBodyRealHeightMobile(actualVisibleHeight - actualHeaderH);
            }
            window.addEventListener("load", lEv);
            window.addEventListener("resize", lEv);

            return () => {
                window.removeEventListener("load", lEv);
                window.removeEventListener("resize", lEv);
            }
        }
    }, []);

    const addRow = (label: string, valueUom: string) => {return <div className="flex justify-content-between flex-nowrap card-container summaryRowContainer">
        <div className="flex align-items-center justify-content-start font-bold plantKPIlabel">{label}</div>
        <div className="flex align-items-center justify-content-end w-12rem h-2rem detailDataContainerHP">{valueUom}</div>
    </div>};

    return <>
        <CustomSidebar refreshAction={() => {refreshData(context, setHomePlants);}}>
            <>
                <h3 className="m-2">Riepilogo</h3>
                <div className="SorgeniaHomeSummary">
                    <div className="cardSummary">
                        {addRow("EE prodotta da inizio giornata", formatNumber(decimalRound(homePlants.map(p => p.eeToday ?? 0).reduce((partial, a) => partial + a, 0), 0)) + " MWh")}
                        {addRow("Produzione attesa per oggi", formatNumber(decimalRound(homePlants.map(p => p.prodExpectedToday ?? 0).reduce((partial, a) => partial + a, 0), 0)) + " MWh")}
                        {addRow("Impianti in marcia", homePlants.filter(p => p.onProd).length + "/" + homePlants.length)}
                    </div>
                    <div className="home-accordion">
                        {Array.from(new Set(homePlants.map(h => h.type!)))
                            .map(t => <HomeAccordionTableComponent type={t} homePlants={homePlants.filter((homePlant: HomePlant) => homePlant.type === t)} key={t} />)}
                    </div>
                </div>
            </>
        </CustomSidebar>
        <div className="map-container" style={bodyRealHeightMobile ? {height: bodyRealHeightMobile + "px"}: {}} onLoad={(event) => {}}>
            <div className="optButtons">
                <Button label="Riepilogo" icon="pi pi-list" onClick={() => context.setSidebarIsOpen!(!context.sidebarIsOpen)} className="overButton" />
            </div>
            {!isMobile({featureDetect: true, tablet: true}) && 
            <div className="miniAccordion">
                <MiniAccordionTable homePlants={homePlants} />
            </div>}
            {isMobile({featureDetect: true, tablet: true}) && width > 400 && 
            <div className="miniAccordion-mobile">
                <MiniAccordionTable homePlants={homePlants} />
            </div>}
            {isMobile({featureDetect: true, tablet: true}) && width <= 400 && 
            <div className="miniAccordion-mobile-xxs">
                <MiniAccordionTable homePlants={homePlants} />
            </div>}
            <MapComponent homePlants={homePlants} />
        </div>
    </>
}

function refreshData(context: MainContext, setHomePlants: React.Dispatch<React.SetStateAction<HomePlant[]>>) {
    context.setInProgressApi!(true);
    GlobalApiFactory({accessToken: context.accessToken!, apiKey: "123"}).globalAllPlantsGet().then((homePlantsAPI: HomePlant[]) => {
        setHomePlants(homePlantsAPI);
        context.setInProgressApi!(false);
    }).catch((e) => {
        console.log(e);
        context.setInProgressApi!(false);
        if (e instanceof InteractionRequiredAuthError) {
            context.doAcquireTokenRedirect();
        }
        else{
            context.showMsg("Errore", "Si è verificato un errore inaspettato nella lettura degli impianti", "error")
        }
    });
}

export default MapPage;